var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 15H5v-4c0-1 1-2 2-2h18c1 0 2 1 2 2v4h-2M7 15v10c0 1 1 2 2 2h14c1 0 2-1 2-2V15M7 15h18m-9-6v18m0-18c-1.333-2.833-4.1-7.4-6.5-5s3 5 6.5 5m0 0c0-4.5 4.5-7.5 6.5-5.5C25 6 20 9 16 9"
  })));
};
export default SvgGift;